const Mutations = Object.freeze({
	SET_ACTIVITY_ITEM:
		'activityBuilder/activityItem/activityItemModal/SET_ACTIVITY_ITEM',
	SET_STATIC_FIELDS:
		'activityBuilder/activityItem/activityItemModal/SET_STATIC_FIELDS',
	SET_GROUP_BY_LISTS:
		'activityBuilder/activityItem/activityItemModal/SET_GROUP_BY_LISTS',
	SET_GROUP_BY_CRITERIA_VALUES:
		'activityBuilder/activityItem/activityItemModal/SET_GROUP_BY_CRITERIA_VALUES',
});

export const Actions = Object.freeze({
	CLEAR: 'activityBuilder/activityItem/activityItemModal/CLEAR',
	LOAD: 'activityBuilder/activityItem/activityItemModal/LOAD',
	LOAD_ACTIVITY_ITEM_BY_ID:
		'activityBuilder/activityItem/activityItemModal/LOAD_ACTIVITY_ITEM_BY_ID',
	LOAD_GROUP_BY_CRITERIA_VALUES:
		'activityBuilder/activityItem/activityItemModal/LOAD_GROUP_BY_CRITERIA_VALUES',
	LOAD_GROUP_BY_LIST:
		'activityBuilder/activityItem/activityItemModal/LOAD_GROUP_BY_LIST',
	LOAD_STATIC_FIELDS:
		'activityBuilder/activityItem/activityItemModal/LOAD_STATIC_FIELDS',
	INSERT: 'activityBuilder/activityItem/activityItemModal/INSERT',
	BULK_INSERT: 'activityBuilder/activityItem/activityItemModal/BULK_INSERT',
	UPDATE: 'activityBuilder/activityItem/activityItemModal/UPDATE',
});

export const Getters = Object.freeze({
	ACTIVITY_ITEM:
		'activityBuilder/activityItem/activityItemModal/ACTIVITY_ITEM',
	STATIC_FIELDS:
		'activityBuilder/activityItem/activityItemModal/STATIC_FIELDS',
	GROUP_BY_LIST:
		'activityBuilder/activityItem/activityItemModal/GROUP_BY_LIST',
	GRID_VIEW_FIELDS_IDS:
		'activityBuilder/activityItem/activityItemModal/GRID_VIEW_FIELDS_IDS',
	GROUP_BY_CRITERIA_VALUES:
		'activityBuilder/activityItem/activityItemModal/GROUP_BY_CRITERIA_VALUES',
	ACTIVITY_ITEM_GROUP_BY_FIELDS_VALUES:
		'activityBuilder/activityItem/activityItemModal/ACTIVITY_ITEM_GROUP_BY_FIELDS_VALUES',
	GRID_VIEW_FIELDS:
		'activityBuilder/activityItem/activityItemModal/GRID_VIEW_FIELDS',
	//getter pt valorile selectate din activityItem
});
import dataService from '../../../../../services/data/activityDataService';
import gridViewFieldUtils from '../../../../../utils/gridViewFieldsUtils';
import { GeneralActions } from '../../../../actions';
export default {
	state: {
		activityItem: null,
		groupByLists: [],
		staticFields: [],
		groupByCriteriaValues: [],
	},
	mutations: {
		[Mutations.SET_ACTIVITY_ITEM](state, item) {
			state.activityItem = item;
		},
		[Mutations.SET_STATIC_FIELDS](state, items) {
			state.staticFields = items;
		},
		[Mutations.SET_GROUP_BY_LISTS](state, items) {
			state.groupByLists = items;
		},
		[Mutations.SET_GROUP_BY_CRITERIA_VALUES](state, items) {
			state.groupByCriteriaValues = items.map((x) => x.Key);
			state.groupByCriteriaValues.forEach((g) => {
				Object.keys(g).forEach((k) => {
					g[k] = '' + g[k];
				});
			});
		},
	},
	actions: {
		[Actions.CLEAR]({ commit }) {
			return new Promise((resolve) => {
				commit(Mutations.SET_ACTIVITY_ITEM, null);
				commit(Mutations.SET_STATIC_FIELDS, []);
				commit(Mutations.SET_GROUP_BY_LISTS, []);
				commit(Mutations.SET_GROUP_BY_CRITERIA_VALUES, []);
				resolve(true);
			});
		},
		[Actions.LOAD]({ dispatch }, { itemId, activityId }) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				let promiseArray = [
					dispatch(Actions.LOAD_STATIC_FIELDS, activityId),
					dispatch(Actions.LOAD_GROUP_BY_LIST, activityId),
				];
				if (itemId)
					promiseArray.push(
						dispatch(Actions.LOAD_ACTIVITY_ITEM_BY_ID, itemId)
					);
				Promise.all(promiseArray)
					.then(() => resolve(true))
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error), resolve(false);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.LOAD_ACTIVITY_ITEM_BY_ID]({ commit, dispatch }, id) {
			return new Promise((resolve) => {
				dataService
					.getActivityItemById(id)
					.then((resp) => {
						commit(Mutations.SET_ACTIVITY_ITEM, resp.data);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					});
			});
		},
		[Actions.LOAD_STATIC_FIELDS]({ commit, dispatch }, activityId) {
			return new Promise((resolve) => {
				dataService
					.getStaticFieldsByActivityId(activityId)
					.then((resp) => {
						commit(Mutations.SET_STATIC_FIELDS, resp.data);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					});
			});
		},
		[Actions.LOAD_GROUP_BY_LIST]({ commit, dispatch }, activityId) {
			return new Promise((resolve) => {
				dataService
					.getGroupByConditionFieldList(activityId)
					.then((resp) => {
						commit(Mutations.SET_GROUP_BY_LISTS, resp.data);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					});
			});
		},
		[Actions.LOAD_GROUP_BY_CRITERIA_VALUES](
			{ commit, dispatch },
			{ activityId, filters }
		) {
			return new Promise((resolve) => {
				dataService
					.getGroupByCriteria(activityId, filters)
					.then((resp) => {
						commit(
							Mutations.SET_GROUP_BY_CRITERIA_VALUES,
							resp.data
						);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					});
			});
		},
		[Actions.INSERT]({ dispatch, state }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				let criteriaValues = [];
				state.groupByLists.forEach((gbl) => {
					gbl.GridViewFields.forEach((gvf) => {
						criteriaValues.push({
							ActivityGroupByConditionFieldGridViewFieldId:
								gvf.Id,
							Value: state.groupByCriteriaValues[0][
								gridViewFieldUtils.getFieldName(gvf)
							],
						});
					});
				});
				item.GroupByCriteria = criteriaValues;
				dataService
					.insertActivityItem(item)
					.then(() => {
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
				dispatch(GeneralActions.LOADING, false);
				resolve(true);
			});
		},
		[Actions.BULK_INSERT]({ dispatch, state }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				let gvf = [].concat(
					...state.groupByLists.map((x) => x.GridViewFields)
				);
				item.GroupByFieldValues.forEach((x) => {
					let criteriaValues = [];
					Object.keys(x).forEach((key) => {
						let gvfId = gvf.find(
							(x) => gridViewFieldUtils.getFieldName(x) == key
						).Id;
						criteriaValues.push({
							ActivityGroupByConditionFieldGridViewFieldId: gvfId,
							Value: x[key],
						});
					});
					item.GroupByCriteria.push(criteriaValues);
				});
				dataService
					.bulkInsertActivityItem(item)
					.then(() => {
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
				dispatch(GeneralActions.LOADING, false);
				resolve(true);
			});
		},
		[Actions.UPDATE]({ dispatch, state }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				let criteriaValues = [];
				state.groupByLists.forEach((gbl) => {
					gbl.GridViewFields.forEach((gvf) => {
						criteriaValues.push({
							ActivityGroupByConditionFieldGridViewFieldId:
								gvf.Id,
							Value: state.groupByCriteriaValues[0][
								gridViewFieldUtils.getFieldName(gvf)
							],
						});
					});
				});
				item.GroupByCriteria = criteriaValues;
				dataService
					.updateActivityItem(item)
					.then(() => {
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
	},
	getters: {
		[Getters.ACTIVITY_ITEM]: (state) => {
			if (!state.activityItem) return [];
			return JSON.parse(JSON.stringify(state.activityItem));
		},
		[Getters.STATIC_FIELDS]: (state) => {
			return JSON.parse(JSON.stringify(state.staticFields));
		},
		[Getters.GROUP_BY_LIST]: (state) => {
			return JSON.parse(JSON.stringify(state.groupByLists));
		},
		[Getters.GRID_VIEW_FIELDS_IDS]: (state) => {
			let result = [];
			if (state.groupByLists.length > 0) {
				result = state.groupByLists
					.map((x) => x.GridViewFieldIds)
					.flat();
			}
			return result;
		},
		[Getters.GRID_VIEW_FIELDS]: (state) => {
			let result = [];
			if (state.groupByLists.length > 0) {
				result = state.groupByLists.map((x) => x.GridViewFields).flat();
			}
			return result;
		},
		[Getters.GROUP_BY_CRITERIA_VALUES]: (state) => {
			return JSON.parse(JSON.stringify(state.groupByCriteriaValues));
		},
		[Getters.ACTIVITY_ITEM_GROUP_BY_FIELDS_VALUES]: (state) => {
			if (!state.activityItem) return [];
			return JSON.parse(
				JSON.stringify(state.activityItem.GroupByCriteria)
			);
		},
	},
};
